// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Keskustelut',
  new_chat: 'Uusi keskustelu',
  note: {
    team: 'Kaikkien keskustelut ravintolassa {{restaurant}}: omasi, tiimisi ja ravintolan.',
    own: 'Omat keskustelusi ravintolassa {{restaurant}}.',
    // No restaurant selected (D18): the person's own chats started that way.
    no_restaurant:
      'Keskustelusi, joissa ei ole valittua ravintolaa. Keskustelu siirtyy ravintolan keskusteluihin, kun valitset sen.',
  },
  log: 'Kaikki pyynnöt Amigo-lokissa',
  days: {
    today: 'Tänään',
    yesterday: 'Eilen',
    earlier: 'Aiemmin',
  },
  who: {
    you: 'Sinä',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Omistaja',
      staff: 'Henkilökunta',
      partner: 'Kumppani',
    },
  },
  status: {
    done: 'Valmis',
    answered: 'Vastattu',
    waiting: 'Odottaa hyväksyntää',
    partial: '{{applied}}/{{total}} toteutettu',
    rejected: 'Hylätty',
    not_yet: 'Ei vielä mahdollista',
    failed: 'Epäonnistui',
  },
  none: {
    title: 'Ei vielä keskusteluja: {{restaurant}}',
    title_no_restaurant: 'Ei vielä keskusteluja ilman valittua ravintolaa',
    text: 'Täällä aloittamasi keskustelut säilyvät täällä, joten voit palata niihin.',
  },
  loading: 'Ladataan keskusteluja…',
  loading_more: 'Ladataan lisää keskusteluja…',
  load_failed: 'Keskusteluja ei voitu ladata.',
  retry: 'Yritä uudelleen',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'Uusi vastaus:',
  new_answers_other: 'Uudet vastaukset:',
};
